.shot-card {
  padding: 0.8rem;
  background: var(--bg-elevation-1);
  border-radius: 0.4rem;
  color: white;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.8rem;
  font-size: 1.4rem;

  &[data-selected='true'] {
    box-shadow: inset 0 0 0 1.5px var(--color-secondary);
  }

  &[data-dragging='true'] {
    opacity: 0;
  }

  &:hover {
    cursor: pointer;
  }

  svg {
    height: 3.2rem;
    width: 3.2rem;
    color: var(--color-texts-low-contrast);
  }
}

.cover {
  height: 3.2rem;
  aspect-ratio: 16 / 9;
  border-radius: var(--border-radius-small);
  overflow: hidden;
  box-sizing: border-box;

  img {
    height: 100%;
    aspect-ratio: 16 / 9;
  }

  &[data-no-cover='true'] {
    border: 1px solid var(--color-grayscale-ghost);
  }
}

.shot-title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
  flex: 1;

  &[data-no-title='true'] {
    color: var(--color-texts-low-contrast);
  }
}
